module.exports = "<div *ngIf=\"active\">\n      <ng-content></ng-content>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/ui-helper/tab/tab.html
// module id = nU5l
// module chunks = 12